export class GetPasswordResetUrlResult {
    url = "";
}
